import React from 'react';
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Switch from "@mui/material/Switch";
import { ListItemButton } from "@mui/material";
import PropTypes from 'prop-types';

const SettingItem = ({ icon, title, subheader, onChangeCallback, isChecked, value }) => {
    return (
        <ListItemButton component={"li"} disableRipple>
            <ListItemIcon sx={{ minWidth: 36 }}>
                {icon}
            </ListItemIcon>
            <ListItemText primary={title} secondary={subheader} />
            {
                onChangeCallback && typeof onChangeCallback === "function" &&
                <Switch
                    edge="end"
                    onChange={() => onChangeCallback(value)}
                    checked={isChecked}
                    size={"small"}
                />
            }
        </ListItemButton>
    );
};

SettingItem.propTypes = {
    icon: PropTypes.element.isRequired,
    title: PropTypes.string.isRequired,
    subheader: PropTypes.string,
    onChangeCallback: PropTypes.func.isRequired,
    isChecked: PropTypes.bool.isRequired,
    value: PropTypes.any.isRequired,
};

export default SettingItem;
